import LightIndicator from './component'

export default LightIndicator
